import { SkeletonBlock, SkeletonWrapper } from '../../Skeleton';
import { OBSIDIAN, PANTERA } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonFeaturedSoftwareCoursesHeader = () => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(SkeletonWrapper, {
      shimmercolor: OBSIDIAN,
      style: {
        width: 220,
        height: 14,
        marginTop: 4,
        marginBottom: 4
      },
      children: /*#__PURE__*/_jsx(SkeletonBlock, {
        color: PANTERA,
        style: {
          width: '100%',
          height: '100%'
        }
      })
    }), /*#__PURE__*/_jsx(SkeletonWrapper, {
      shimmercolor: OBSIDIAN,
      style: {
        width: 180,
        height: 14,
        marginTop: 4,
        marginBottom: 4
      },
      children: /*#__PURE__*/_jsx(SkeletonBlock, {
        color: PANTERA,
        style: {
          width: '100%',
          height: '100%'
        }
      })
    })]
  });
};
export default SkeletonFeaturedSoftwareCoursesHeader;